import { AppStateFlow } from './app.flow';
import { Features } from './common/config/feature.constants';
import { startStateName } from './components/start/start.state';

export const ProgressableStates = (hasStatus) =>
  Object.values(AppStateFlow(hasStatus)).filter(
    (step) => step.progressbarVisible,
  );

export const appState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    abstract: true,
    name: 'app',
    redirectTo: 'start',
    template: '<app />',
    resolve: {
      languageOptions: ($translate, $locale, controllerService) => {
        'ngInject';
        const lang = $translate.use();
        return controllerService.tmhDynamicLocale.set(lang).then(() => {
          const { longDate, mediumDate, shortDate } = $locale.DATETIME_FORMATS;
          return {
            lang,
            dateFormat: longDate,
            longDate,
            mediumDate,
            shortDate,
          };
        });
      },
    },
  });
};

/**
 * Check if the given state is accessible by stateProvider.
 *
 * @param {string} stateName Name of the state to resolve
 */
export const stateResolver = (stateName) => [
  '$state',
  '$q',
  'appCache',
  'configService',
  function ($state, $q, appCache, configService) {
    const deferred = $q.defer();
    const hasStatusPage = configService.isFeatureActive(Features.hasStatusPage);

    let rejectState;
    // Check for the given state if all required values are available.
    const stateConfig = AppStateFlow(hasStatusPage)[stateName];
    if (stateConfig && stateConfig.requires) {
      const { requires } = stateConfig;
      requires.forEach((key) => {
        rejectState = rejectState || !appCache.get(key);
      });
    }

    // console.log('stateResolver', { stateName, rejectState });
    // Reject the resolve request and fallback to last accessed state or defaults to start
    if (rejectState) {
      deferred.reject();
      const lastStateIndex = appCache.get('lastStateIndex');
      const lastState = ProgressableStates(hasStatusPage)[lastStateIndex] || {
        stateName: startStateName,
      };
      $state.go(lastState.stateName);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  },
];



// WEBPACK FOOTER //
// ./src/app/app.state.js